function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { prefix as stylisPrefix } from 'stylis';
import { cssifyDeclaration, camelCaseProperty } from 'css-in-js-utils';
import { objectReduce } from 'fast-loops';
import isPlainObject from 'isobject';

function addVendorPrefixes(style) {
  return objectReduce(style, function (prefixedStyle, value, property) {
    if (isPlainObject(value)) {
      prefixedStyle[property] = addVendorPrefixes(value);
    } else {
      var cssDeclaration = cssifyDeclaration(property, value) + ';';
      var prefixed = stylisPrefix(cssDeclaration, property.length);

      if (prefixed !== cssDeclaration) {
        var _prefixed$split = prefixed.split(/:(.+)/),
            _prefixed$split2 = _slicedToArray(_prefixed$split, 2),
            _property = _prefixed$split2[0],
            _value = _prefixed$split2[1]; // TODO: do we really need to camelCase here?


        prefixedStyle[camelCaseProperty(_property)] = _value.slice(0, -1);
      } else {
        prefixedStyle[property] = value;
      }
    }

    return prefixedStyle;
  }, {});
}

addVendorPrefixes.optimized = function (props) {
  var cssDeclaration = cssifyDeclaration(props.property, props.value) + ';';
  var prefixed = stylisPrefix(cssDeclaration, props.property.length);

  if (prefixed !== cssDeclaration) {
    var _prefixed$split3 = prefixed.split(/:(.+)/),
        _prefixed$split4 = _slicedToArray(_prefixed$split3, 2),
        property = _prefixed$split4[0],
        value = _prefixed$split4[1]; // TODO: do we really need to camelCase here?


    props.property = camelCaseProperty(property);
    props.value = value.slice(0, -1);
  }

  return props;
};

export default (function () {
  return addVendorPrefixes;
});